// src/context/AdminContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  // Persistent states using localStorage
  const [selectedProductStore, setSelectedSProductStore] = useState(() => {
    return JSON.parse(localStorage.getItem("selectedProductStore")) || null;
  });

  const [showSummary, setShowSummary] = useState(() => {
    return JSON.parse(localStorage.getItem("showSummary")) || false;
  });

  const [showCatalogue, setShowCatalogue] = useState(() => {
    return JSON.parse(localStorage.getItem("showCatalogue")) || false;
  });

  const [pinModelOpen, setPinModelOpen] = useState(false);
  const [orderModel, setOrderModel] = useState(false);

  const [customerStoreOwnerData, setCustomerStoreOwnerData] = useState(() => {
    return JSON.parse(localStorage.getItem("customerStoreOwnerData")) || "";
  });

  const [pinData, setPinData] = useState(() => {
    return JSON.parse(localStorage.getItem("pinData")) || "";
  });

  const [updateModel, setUpdateModel] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [isModalCurrentPinOpen, setIsModalCurrentPinDeleteOpen] =
    useState(false);

  //   const [cartData, setCartData] = useState([]);
  const [cartData, setCartData] = useState(() => {
    return JSON.parse(localStorage.getItem("cartData")) || [];
  });

  const [storeOwnerCart, setStoreOwnerCart] = useState(() => {
    return JSON.parse(localStorage.getItem("storeOwnerCart")) || [];
  });

  // Sync to localStorage whenever changes happen
  useEffect(() => {
    localStorage.setItem(
      "selectedProductStore",
      JSON.stringify(selectedProductStore),
    );
  }, [selectedProductStore]);

  useEffect(() => {
    localStorage.setItem("cartData", JSON.stringify(cartData));
  }, [cartData]);

  useEffect(() => {
    localStorage.setItem("storeOwnerCart", JSON.stringify(storeOwnerCart));
  }, [storeOwnerCart]);

  useEffect(() => {
    localStorage.setItem("showSummary", JSON.stringify(showSummary));
  }, [showSummary]);

  useEffect(() => {
    localStorage.setItem("showCatalogue", JSON.stringify(showCatalogue));
  }, [showCatalogue]);

  useEffect(() => {
    localStorage.setItem(
      "customerStoreOwnerData",
      JSON.stringify(customerStoreOwnerData),
    );
  }, [customerStoreOwnerData]);

  useEffect(() => {
    localStorage.setItem("pinData", JSON.stringify(pinData));
  }, [pinData]);

  return (
    <AdminContext.Provider
      value={{
        // Core state
        selectedProductStore,
        setSelectedSProductStore,
        showSummary,
        setShowSummary,
        showCatalogue,
        setShowCatalogue,
        pinModelOpen,
        setPinModelOpen,
        orderModel,
        setOrderModel,
        customerStoreOwnerData,
        setCustomerStoreOwnerData,
        pinData,
        setPinData,
        updateModel,
        setUpdateModel,
        isModalDeleteOpen,
        setIsModalDeleteOpen,
        isModalCurrentPinOpen,
        setIsModalCurrentPinDeleteOpen,
        setCartData,
        cartData,
        setStoreOwnerCart,
        storeOwnerCart,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

// Custom hook to consume context
export const useAdminContext = () => useContext(AdminContext);
